import React, { useState, useEffect, useRef, useCallback } from "react";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import ModalDraggable from "../ModalDraggable";
import Trash from "../Trash";
import Spinner from "../../components/Spinner";
import Reload from "../Reload";

const ModalShowAssessmentItems = (props) => {
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [isInitialized, setIsInitialized] = useState(false);
  const dragStateRef = useRef(false);
  useEffect(() => {
    if (props.assessmentIaCreated && props.assessmentIaCreated.questions) {
      setItems(props.assessmentIaCreated.questions);
      setIsInitialized(true);
    }
  }, [isInitialized, props.assessmentIaCreated]);

  const handleDragStart = useCallback(() => {
    dragStateRef.current = true;
  }, []);

  const handleDragEnd = useCallback((result) => {
    dragStateRef.current = false;

    if (!result.destination) {
      return;
    }

    setItems((currentItems) => {
      const newItems = Array.from(currentItems);
      const [removed] = newItems.splice(result.source.index, 1);
      newItems.splice(result.destination.index, 0, removed);
      return newItems;
    });
  }, []);

  const handleDelete = (indexToDelete) => {
    setItems((prevItems) =>
      prevItems.filter((_, idx) => idx !== indexToDelete),
    );
  };

  const handleRegenerate = (identifier) => {
    console.log(identifier);
    setLoading(true);
    props.updateItem(
      identifier,
      props.assessmentIaCreated.assessment_id,
      (response) => successUpdateItem(response, identifier),
    );
  };

  const successUpdateItem = (response, identifier) => {
    console.log("successUpdateItem");

    let new_item = response["new_item"];
    new_item["identifier"] = identifier;
    const index = items.findIndex((q) => q.identifier === identifier);
    if (index !== -1) {
      setItems((currentItems) => {
        const newItems = Array.from(currentItems);
        newItems[index] = new_item;
        return newItems;
      });
    }
    setLoading(false);
  };

  console.log(items);
  return (
    <ModalDraggable
      style={{ display: "block" }}
      isVisible={props.showModalInfoAction}
      big={true}
    >
      {loading && <Spinner />}
      <div style={{ display: "block" }}>
        <h4 className="o-text-align--center">{props.text}</h4>
        <div style={{ minHeight: "200px" }}>
          <DragDropContext
            onDragStart={handleDragStart}
            onDragEnd={handleDragEnd}
          >
            <Droppable
              isDropDisabled={false}
              isCombineEnabled={false}
              ignoreContainerClipping={false}
              type="QUESTION"
              droppableId="question-list"
            >
              {(provided, snapshot) => (
                <div
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                  style={{
                    minHeight: "100px",
                    padding: "10px",
                    backgroundColor: snapshot.isDraggingOver
                      ? "#f5f5f5"
                      : "transparent",
                  }}
                >
                  {isInitialized &&
                    items.map((question, index) => {
                      const itemId = `question-${question.identifier}`;
                      return (
                        <Draggable
                          key={itemId}
                          draggableId={itemId}
                          index={index}
                        >
                          {(provided, snapshot) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              style={{
                                userSelect: "none",
                                padding: "15px",
                                margin: "0 0 10px 0",
                                backgroundColor: snapshot.isDragging
                                  ? "#e3f2fd"
                                  : "#ffffff",
                                border: "2px solid",
                                borderColor: snapshot.isDragging
                                  ? "#2196f3"
                                  : "#e0e0e0",
                                borderRadius: "8px",
                                cursor: "grab",
                                ...provided.draggableProps.style,
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginBottom: "10px",
                                  gap: '12px',
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: '4px',
                                    alignSelf: 'flex-start',
                                  }}
                                >
                                  <span
                                    style={{
                                      fontSize: "16px",
                                      color: "#dfdfdf",
                                    }}
                                    title="Arrastrar"
                                  >
                                    ☰{" "}
                                  </span>
                                  <span
                                    style={{
                                      background: "#76b0eb",
                                      color: "white",
                                      fontFamily: 't3-bold',
                                      borderRadius: "50%",
                                      width: "24px",
                                      height: "24px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      fontSize: "12px",
                                    }}
                                  >
                                    {index + 1}
                                  </span>
                                </div>
                                <h4 style={{ margin: 0, flex: 1 }}>
                                  {question.title}
                                </h4>
                                <div style={{ display: "flex", gap: "8px" }}>
                                  {
                                    <button
                                      onClick={() =>
                                        handleRegenerate(question.identifier)
                                      }
                                      style={{
                                        width: "32px",
                                        height: "32px",
                                        border: "none",
                                        cursor: "pointer",
                                        cursor: "pointer",
                                        display: 'flex',
                                        alignItems: 'center',
                                      }}
                                      title="Regenerar"
                                    >
                                      <Reload width="32px" height="32px" />
                                    </button>
                                  }
                                  <button
                                    onClick={() => handleDelete(index)}
                                    style={{
                                      width: "32px",
                                      height: "32px",
                                      borderRadius: "50%",
                                      border: "none",
                                      cursor: "pointer",
                                      display: 'flex',
                                      alignItems: 'center',
                                    }}
                                    title="Eliminar"
                                  >
                                    <Trash />
                                  </button>
                                </div>
                              </div>
                              <div style={{ paddingLeft: "34px" }}>
                                {Object.keys(question.items || {}).map(
                                  (key_item, optionIndex) => {
                                    const item = question.items[key_item];
                                    return (
                                      <p
                                        key={key_item}
                                        style={{
                                          margin: "5px 0",
                                          padding: "5px",
                                          backgroundColor:
                                            item.value > 0
                                              ? "#1dd1a1"
                                              : "#f9f9f9",
                                          color:
                                            item.value > 0 ? "white" : "#666",
                                          borderRadius: "4px",
                                          borderColor: item.value > 0 ? "#87FF4E" : "transparent",
                                          fontSize: "14px",
                                        }}
                                      >
                                        <strong>
                                          {String.fromCharCode(
                                            65 + optionIndex,
                                          )}
                                          )
                                        </strong>{" "}
                                        {item.text}
                                      </p>
                                    );
                                  },
                                )}
                              </div>
                            </div>
                          )}
                        </Draggable>
                      );
                    })}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </div>
        <div
          className="c-modal__buttons-wrapper"
          style={{ width: "fit-content", marginInline: "auto" }}
        >
          <button
            type="button"
            className="c-button c-button--cancel c-modal__button"
            onClick={() => props.closeModalInfoAction()}
          >
            <span className="c-button__text">Cancel</span>
          </button>
          <button
            type="button"
            className="c-button c-modal__button"
            onClick={() =>
              props.updateAssessment(
                items,
                props.assessmentIaCreated.assessment_id,
              )
            }
          >
            <span className="c-button__text">{"Confirm"}</span>
          </button>
        </div>
      </div>
    </ModalDraggable>
  );
};
export default ModalShowAssessmentItems;
